export default "__VITE_ASSET__m5D38Oga__"